import { render } from "./featureComponent.vue?vue&type=template&id=60c50a46&scoped=true"
import script from "./featureComponent.vue?vue&type=script&lang=js"
export * from "./featureComponent.vue?vue&type=script&lang=js"

import "./featureComponent.vue?vue&type=style&index=0&id=60c50a46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c50a46"]])

export default __exports__